module.exports = "https://99designs-start-assets.imgix.net/js/01c92f5017896b735db490358f560e6b.svg";